import { RouteStore } from 'bernie-core';

export const showTerms = event => {
  const routeStore: RouteStore = event;
  if (routeStore && routeStore.updateSearch) {
    routeStore.updateSearch({ pwaDialog: 'couponTerms' });
  }
};

export const openMoreDetails = event => {
  const routeStore: RouteStore = event;
  if (routeStore && routeStore.updateSearch) {
    routeStore.updateSearch({ pwaDialog: 'freeLxTerms' });
  }
};
